import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { EntitlementService } from '../../services/entitlement.service';
import { Ship } from '../../Ship';
import { ShipsContact } from '../../data/ShipsContact';
import { ShipService } from '../../services/ship.service';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MessageService } from '../../services/message.service';
import { ShipInstallation } from 'src/app/data/ShipInstallation';

@Component({
  selector: 'app-ship-pending',
  templateUrl: './ship-pending.component.html',
  styleUrls: ['./ship-pending.component.css']
})
export class ShipPendingComponent implements OnInit {
  @Output() registerCancel = new EventEmitter();
  newShipForm: UntypedFormGroup;
  ships: ShipInstallation[];
  shipLocations: string[];
  locationType: string;
  shipsContact: ShipsContact;
  processing = false;
  page: number = 1;
  pageSize: number = 25;

  constructor(
    private entitlementService: EntitlementService,
    private shipService: ShipService,
    private messageService: MessageService
  ) {
    this.shipLocations = [];
  }

  ngOnInit() {
    this.initForm();

    this.shipService.getShipContactBlank().subscribe(
      (data: ShipsContact) => {
        this.shipsContact = data;
      },
      (error) => {
        console.log('Error calling Ship Contact Blank: ' + error);
      }
    );

    this.shipService.getAllPendingShips().subscribe(
      (data) => {
        this.ships = data;
        this.ships.sort((objA, objB) =>
         new Date(objB.dateModified).getTime() - new Date(objA.dateModified).getTime());
      },
      (error) => {
        console.log('Error getting all pending ships: ' + error);
      },
      () => {}
    );

    this.shipService.getShipsCommon().subscribe(
      (data) => {
        data.forEach((ship) => {
          this.shipLocations.push(ship.shipLocation);
        });
      },
      (error) => {
        console.log('Error getting ship locations: ' + error);
      },
      () => {}
    );
  }

  initForm() {
    this.newShipForm = new UntypedFormGroup({
      locationType: new UntypedFormControl('')
    });
  }

  changeType(type: string, shipUuid: string) {
    if(this.shipLocations.indexOf(type) == -1){
      (<HTMLInputElement>(
        document.getElementById('button-' + shipUuid)
      )).disabled = true;
    } else {
      this.locationType = this.shipLocations.filter((t) => t === type)[0]; // Should always resolve and no IndexOutOfBounds should be thrown
      (<HTMLInputElement>(
        document.getElementById('button-' + shipUuid)
      )).disabled = false;
    }
  }

  hasEntitlement(entitlement: string) {
    return this.entitlementService.hasEntitlement(entitlement);
  }

  pairShip(shipUuid: string) {
    this.processing = true;

    this.shipService.pairShip(shipUuid, this.locationType).subscribe(
      (data) => {
        // do nothing
      },
      (error) => {
        console.log(
          "An error occurred pairing ship with UUID '" +
            shipUuid +
            "': " +
            error
        );
        this.messageService.error(
          "An error occurred pairing ship '" + this.locationType + "'"
        );
      },
      () => {
        document.getElementById(shipUuid).remove();
        this.ngOnInit(); // Render table and pagination again with the removed element
        this.messageService.success('Ship paired successfully');
      }
    );

    this.processing = false;
  }
}
